import {
  Box,
  Button
} from '@mui/material';
import {
  ChatBubble,
  MessageDataModal,
  MessageDataTable
} from 'modules';

import { DateTime } from 'luxon';
import { MessageData } from 'generated/graphql';
import { useParams } from 'react-router-dom';
import { useState } from 'react';



export type MessageProps = {
  role: 'SHERLOCK' | 'USER';
  message: string;
  ticker: string;
  sentTimestamp: DateTime;
  relevantData?: MessageData | null;
};

export const FC = (props: MessageProps) => {
  const params = useParams<{ companyId: string }>();

  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      {props.relevantData && (
        <MessageDataModal.FC
          ticker={props.ticker}
          isVisible={isVisible}
          data={props.relevantData}
          handleClose={() => setIsVisible(() => false)}
        />
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: props.role === 'SHERLOCK' ? 'flex-start' : 'flex-end',
          flexDirection: 'column',
          gap: 1
        }}
      >
        <ChatBubble.FC
          role={props.role}
          text={props.message}
          sentTimestamp={props.sentTimestamp}
        />

        {props.relevantData && (
          <Box sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
          >
            <Box sx={{
              width: '100%'
            }}
            >
              <MessageDataTable.FC
                messageData={props.relevantData}
              />
            </Box>

            <Button
              onClick={() => {
                if (props.relevantData?.type === 'deepDive') {
                  window.open(`/company/${params.companyId}/revenueDeepDive`, '_blank');
                } else if (props.relevantData?.type === 'earningsCall') {
                  window.open(`/company/${params.companyId}/earningsCall`, '_blank');
                } else {
                  setIsVisible(() => true);
                }
              }}
              variant='contained'
              color='secondary'
              sx={{
                mt: 1,
                width: '50%'
              }}
            >
              Review Complete Analysis
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};
